// Centralised endpoint path constants for the treasury fiat-transactions
// module. Backend route renames are a one-file change.

const FIAT_TRANSACTIONS = '/api/admin/treasury/fiat-transactions'

export const FIAT_TRANSACTIONS_ENDPOINT_PATHS = {
  LIST: FIAT_TRANSACTIONS,
  DOWNLOAD: `${FIAT_TRANSACTIONS}/download`,
  DETAIL: (id: string) => `${FIAT_TRANSACTIONS}/${id}`,
} as const
